import React, { useContext } from 'react';
import './style.scss';
import clsx from 'clsx';
import { SearchContext } from '../context/SearchContext';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import CloseIcon from './CloseIcon';

const SearchTitle = () => {
  const { title } = useContext(SearchContext);
  const shouldRenderTitle = !!title && title?.value !== '';

  return (
    <>
      {shouldRenderTitle && (
        <div className="popup-search-title-wrap">
          <RichText className={clsx('popup-search-title')} field={title} />
          <CloseIcon className={'close-search-popup'} />
        </div>
      )}
    </>
  );
};

export default SearchTitle;
